import { Form } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Input } from "@vds/inputs";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { createOrgList, updateOrgList } from "../../../global/utility/Utils";
import { DeleteOrganizationModal } from "../organizationModel";
import { deleteOrganizationEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";

import ToastNotification from "../../../global/components/ToastNotification";
import ValidationIcon, {
  getInputClassNamesUser,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";

const CreateOrganization = ({ visible, closePopup, state, onOrgCreated }) => {
  let navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  // let { state } = useLocation();

  let editRole = false;
  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteOrg, setShowDeleteOrg] = useState(false);
  const [deleteOrgConfirmed, setDeleteOrgConfirmed] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [typeNotific, setTypeNotific] = useState("error");
  const [msgNotific, setMsgNotific] = useState("");
  const [notificationProps, setNotificationProps] = useState({});
  const [formData, setFormData] = useState({
    orgName: "",
  });

  const [errors, setErrors] = useState({
    orgName: "initial",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let tempErrors = { ...errors };
    switch (name) {
      case "orgName":
        tempErrors.orgName = value ? "" : "Organization Name is required";
        break;
      default:
        break;
    }
    setErrors(tempErrors);
  };

  const handleSubmit = async () => {
  let tempErrors = { ...errors };
  tempErrors.orgName = formData.orgName
    ? ""
    : "Organization Name is required";
  setErrors(tempErrors);

  // If there are any errors, just return without proceeding
  if (Object.values(tempErrors).some((x) => x !== "")) {
    return;
  }

  // Proceed with form submission if there are no errors
  if (selectedItem) {
    const updatedList = dataList?.map((item) =>
      item.id === selectedItem.id ? formData : item
    );
    const response = await updateOrgList({ ...formData });
    if (response?.id) {
      setNotificationProps({
        type: "success",
        message: "Edit Organization",
        description: `Organization "${selectedItem?.orgName}" updated successfully`,
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
        onOrgCreated();
      }, 1000);
    } else {
      setNotificationProps({
        type: "error",
        message: "Edit Organization",
        description: `Organization update failed`,
        duration: 1,
        style: { backgroundColor: "#FFECE0", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    }
    setSelectedItem(null);
  } else {
    const newItem = { id: Date.now(), ...formData };
    const response = await createOrgList(newItem);
    setDataList([...dataList, newItem]);
    if (response[0]?.id) {
      setFormData({
        orgName: "",
      });
      setNotificationProps({
        type: "success",
        message: "Add Organization",
        description: `Organization "${response[0]?.name}" created successfully`,
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        onOrgCreated();
        setShowNotification(false);
      }, 1000);
    } else {
      setNotificationProps({
        type: "error",
        message: "Add Organization",
        description: "Organization creation failed",
        duration: 1,
        style: { backgroundColor: "#FFECE0", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    }
  }
};

  const deleteOrg = () => {
    setShowDeleteOrg(true);
  };

  const onConfirm = async () => {
    setDeleteOrgConfirmed(true);
    setShowDeleteOrg(false);

    const response = await fetch(deleteOrganizationEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        tagId: state?.id,
      }),
    });
    const deleteOrgRsp = await response;
    if (deleteOrgRsp) {
      if (deleteOrgRsp?.status === 200 || deleteOrgRsp?.status === 204) {
        setFormData({
          orgName: "",
        });
        setTypeNotific("success");
        setMsgNotific("Organization was deleted successfully");
        setShowNotification(true);
        setTimeout(() => {
          navigate("/organization");
        }, 1000);
      } else {
        setTypeNotific("error");
        setMsgNotific("Organization deleted failed");
        setShowNotification(true);
      }
    }
  };
  const onExit = () => {
    setDeleteOrgConfirmed(false);
    setShowDeleteOrg(false);
    navigate(-1);
  };
  const handleClose = () => {
    setShowNotification(false);
  };
  useEffect(() => {
    if (state) {
      if (user?.role?.permissions?.organizations?.edit) {
        setSelectedItem({
          orgName: state?.tags?.[0]?.org_name || state?.org_name || state?.name || 'Unknown',
        });
        setFormData({
          orgName: state?.tags?.[0]?.org_name || state?.org_name || state?.name || 'Unknown',
          kind: state?.tags?.[0]?.kind || state?.kind || 'Unknown',
          id: state?.id || 'Unknown',
        });
      } else if (!user?.role?.permissions?.organizations?.create) {
        navigate("/organization");
      }
    } else if (!user?.role?.permissions?.organizations?.create) {
      navigate("/organization");
    }
  }, [state, user, navigate]);

  return (
    <>
      <Modal
        title=""
        open={visible}
       // visible={visible}
        onCancel={() => closePopup(false)}
        footer={[
          <Grid2
            container
             marginTop={0}
            marginBottom={-1}
            spacing={2}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-0">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  onClick={() => closePopup(false)}
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  onClick={handleSubmit}
                  shape="round"
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  size={"large"}
                >
                  {state !== null ? "Save" : "Add"}
                </Button>
              </div>
            </Grid2>
          </Grid2>,
        ]}
        width={680}
      >
        {showNotification && (
          <ToastNotification
            type={notificationProps.type}
            message={notificationProps.message}
            description={notificationProps.description}
            duration={notificationProps.duration}
            style={notificationProps.style}
          />
        )}
        <div style={{ marginBottom: "5px", marginTop:"5px" }}>
        <h2 className={"font-face-vzb page-header-location"}>
           {state !== null ? "Edit Organization" : "Add Organization"}
        </h2>
      </div>
        <Form>
          <Grid2
            container
            marginTop={2}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
              <div className="mb-1">
                  <label className="input-label-user"> Organization name</label>
                <div className="input-container">
                  <Input
                    type="text"
                    id="orgName"
                    name="orgName"
                    value={formData.orgName}
                    onChange={(e) => handleChange(e)}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                    error={errors.orgName !== "initial" && errors.orgName !== ""}
                    errorText={errors.orgName !== "initial" ? errors.orgName : ""}
                    required={false}
                  />
                </div>
              </div>
            </Grid2>
          </Grid2>
          <DeleteOrganizationModal
            showDeleteOrg={showDeleteOrg}
            setShowDeleteOrg={setShowDeleteOrg}
            message="Are you sure you want to delete the Organization"
            title="Delete Organization"
            onConfirm={onConfirm}
            onExit={onExit}
          />
        </Form>
      </Modal>
    </>
  );
};

export default CreateOrganization;
